import { css } from '@emotion/css';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ReactComponent as Arrow } from '../../assets/images/arrow_suggestion.svg';
import { Dialog } from '../shared/dialog/Dialog';
import { reveal } from '../shared/keyframe-animations';
import { Photo } from '../shared/Photo';

export const MyDesignHintDialog: React.FC = () => {
  const { t } = useTranslation('my_design');
  return (
    <Dialog hasHeader={true}>
      <div
        className={css`
          color: #938666;
          text-align: center;

          h1 {
            color: #4d3906;
            font-size: 20px;
            text-align: center;
          }
          section:last-child {
            padding-bottom: 40px;
          }
          .photo {
            width: 278px;
            height: 180px;
            margin: 32px auto;
            position: relative;
          }
          .photo1 {
            display: flex;
            justify-content: center;
          }
          .leaf-title {
            position: absolute;
            top: 22px;
            left: 0;
            right: 0;
            color: #f8f0d9;
            font-size: 8px;
            text-align: center;
            margin: 0 auto;
          }
          .download {
            display: flex;
            align-items: center;
            position: absolute;
            bottom: -8px;
            right: -12px;
          }
          .plus {
            display: flex;
            align-items: center;
            background: #f5f7e1;
            box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.1);
            border-radius: 40px;
            padding: 0 8px 0 4px;
            color: #897a66;
            transform: rotate(-2deg);
            position: relative;
            height: 36px;

            &::before {
              content: '\ue0f0';
              font-size: 24px;
              margin-right: 4px;
            }
          }
          .arrow {
            position: absolute;
            bottom: 40px;
            right: 16px;
            transform: scaleY(-1) rotate(2deg);
            @media (prefers-reduced-motion: no-preference) {
              svg {
                transform: translateY(-4px);
                animation: ${reveal} 0.4s ease-in-out infinite alternate;
              }
            }
          }
          .left-rotate {
            transform: rotate(-2deg);
          }
          .right-rotate {
            transform: rotate(2deg);
          }
          /* less than iPhone6/7/8 display size */
          @media screen and (max-width: 374px) {
            font-size: 14px;
            h1 {
              font-size: 18px;
            }
            .photo {
              width: 214px;
              height: 140px;
            }
            .leaf-title {
              top: 18px;
              font-size: 7px;
            }
          }
        `}
      >
        <h1>{t('help')}</h1>
        <section>
          <div className="photo left-rotate photo1">
            <Photo
              srcSet={`
              /images/my-design/img_mydesign_hint_01-2x.jpg 2x,
              /images/my-design/img_mydesign_hint_01.jpg 1x
            `}
            />
            <p className="leaf-title" aria-hidden={true}>
              {t('help_desc_03')}
            </p>
          </div>
          <p>{t('help_desc_01')}</p>
          <p>{t('help_desc_04')}</p>
        </section>
        <section>
          <div className="photo right-rotate photo2">
            <Photo
              srcSet={`
              /images/my-design/img_mydesign_hint_02-2x.jpg 2x,
              /images/my-design/img_mydesign_hint_02.jpg 1x
            `}
            />
            <div className="download" aria-hidden={true}>
              <div className="plus">{t('download')}</div>
              <div className="arrow">
                <Arrow />
              </div>
            </div>
          </div>
          <p>{t('help_desc_02')}</p>
        </section>
      </div>
    </Dialog>
  );
};
